"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerCSSVars: function() {
        return drawerCSSVars;
    },
    drawerDefaultStyles: function() {
        return drawerDefaultStyles;
    },
    useDrawerBottomBaseStyles: function() {
        return useDrawerBottomBaseStyles;
    },
    useDrawerDurationStyles: function() {
        return useDrawerDurationStyles;
    },
    useDrawerBaseClassNames: function() {
        return useDrawerBaseClassNames;
    }
});
const _react = require("@griffel/react");
const _reacttheme = require("@fluentui/react-theme");
const drawerCSSVars = {
    drawerSizeVar: '--fui-Drawer--size'
};
const drawerDefaultStyles = {
    .../*#__PURE__*/ _react.shorthands.overflow('hidden'),
    width: `var(${drawerCSSVars.drawerSizeVar})`,
    maxWidth: '100vw',
    height: 'auto',
    maxHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    backgroundColor: _reacttheme.tokens.colorNeutralBackground1,
    color: _reacttheme.tokens.colorNeutralForeground1
};
/**
 * Shared dynamic styles for the Drawer component
 */ const useDrawerStyles = /*#__PURE__*/ (0, _react.__styles)({
    entering: {
        Bkqvd7p: "f18ad807"
    },
    exiting: {
        Bkqvd7p: "f1mfizis"
    },
    reducedMotion: {
        Hwfdqs: "f5e8c63"
    },
    start: {
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        j35jbq: [
            "fvfyk4",
            "frppm18"
        ]
    },
    end: {
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        oyh7mz: [
            "frppm18",
            "fvfyk4"
        ]
    },
    bottom: {
        B5kzvoi: "f1yab3r1",
        Bhzewxz: "f198g47y"
    },
    small: {
        Bjr0ffy: "f1exhnwo"
    },
    medium: {
        Bjr0ffy: "fqofjzu"
    },
    large: {
        Bjr0ffy: "fce6y3m"
    },
    full: {
        Bjr0ffy: "fsdmzs6"
    }
}, {
    d: [
        ".f18ad807{transition-timing-function:var(--curveDecelerateMid);}",
        ".f1mfizis{transition-timing-function:var(--curveAccelerateMin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".f1vgc2s3{left:0;}",
        ".f1e31b4d{right:0;}",
        ".fvfyk4{right:auto;}",
        ".frppm18{left:auto;}",
        ".f1yab3r1{bottom:0;}",
        ".f198g47y{top:auto;}",
        ".f1exhnwo{--fui-Drawer--size:320px;}",
        ".fqofjzu{--fui-Drawer--size:592px;}",
        ".fce6y3m{--fui-Drawer--size:940px;}",
        ".fsdmzs6{--fui-Drawer--size:100vw;}"
    ],
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.f5e8c63{transition-duration:0.001ms;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const useDrawerBottomBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    small: {
        Bjr0ffy: "f1exhnwo"
    },
    medium: {
        Bjr0ffy: "fqofjzu"
    },
    large: {
        Bjr0ffy: "fce6y3m"
    },
    full: {
        Bjr0ffy: "fno8cgj"
    }
}, {
    d: [
        ".f1exhnwo{--fui-Drawer--size:320px;}",
        ".fqofjzu{--fui-Drawer--size:592px;}",
        ".fce6y3m{--fui-Drawer--size:940px;}",
        ".fno8cgj{--fui-Drawer--size:100vh;}"
    ]
});
const useDrawerDurationStyles = /*#__PURE__*/ (0, _react.__styles)({
    small: {
        B3o57yi: "fc397y7"
    },
    medium: {
        B3o57yi: "f78771"
    },
    large: {
        B3o57yi: "f9ymmep"
    },
    full: {
        B3o57yi: "f1loko9l"
    }
}, {
    d: [
        ".fc397y7{transition-duration:var(--durationGentle);}",
        ".f78771{transition-duration:var(--durationSlow);}",
        ".f9ymmep{transition-duration:var(--durationSlower);}",
        ".f1loko9l{transition-duration:var(--durationUltraSlow);}"
    ]
});
const useDrawerBaseClassNames = ({ position, size, motion })=>{
    const baseStyles = useDrawerStyles();
    const bottomBaseStyles = useDrawerBottomBaseStyles();
    const durationStyles = useDrawerDurationStyles();
    return (0, _react.mergeClasses)(baseStyles[position], position === 'bottom' && bottomBaseStyles[size], durationStyles[size], position !== 'bottom' && baseStyles[size], baseStyles.reducedMotion, motion.type === 'entering' && baseStyles.entering, motion.type === 'exiting' && baseStyles.exiting);
}; //# sourceMappingURL=useDrawerBaseStyles.styles.js.map
